import { Controller } from "@hotwired/stimulus";
import { debounce } from 'throttle-debounce';

export default class extends Controller {
	static targets = ['container'];

    connect() {
        document.addEventListener("scroll", (event) => {
            this.refreshNavigation();
        });
    }

    refreshNavigation() {
        const bounds = this.containerTarget.getBoundingClientRect();

        if(0 > bounds.bottom) {
            if (!this.containerTarget.hasAttribute('data-group-active')) {
                this.containerTarget.setAttribute('data-group-active', true);
            } 
        }else {
            if (this.containerTarget.hasAttribute('data-group-active')) {
                this.containerTarget.removeAttribute('data-group-active');
            } 
        }
    }
}
